import type {MouseEventHandler} from 'react';

export const ICON_CROWN = 'icon-crown';
export const ICON_SKIPPED = 'icon-minus';
export const ICON_COMPLETED = 'icon-check-filled';

export interface PromotionChecklistItemProps {
  itemIdentifier: string;
  text: string;
  /** The step's own icon, shown while the step is neither done, skipped nor upsold. */
  stepIcon: string;
  isComplete?: boolean;
  /** Celebrated as just completed (`4724:45447`): a 24px check and 16px bold label. */
  isEmphasized?: boolean;
  isSkipped?: boolean;
  hasPremiumUpselling?: boolean;
  onClick?: MouseEventHandler;
}

export interface ChecklistItemLeadingIcon {
  icon: string;
  className: string;
}
